import React, { useRef, useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import loadOptions from './load-options'
import AirportOption from './airport-option'

const customComponents = { Option: AirportOption }

export const getReactSelectTheme = theme => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary: '#bd9973',
  },
  spacing: {
    baseUnit: 4,
    controlHeight: '100%',
    menuGutter: 1,
  },
})

const AirportPicker = props => {
  const { t } = useTranslation()
  const noOptionsMessage = s =>
    s.length > 2 ? t('No options') : t('Search for city, IATA or ICAO code')
  const loadingMessage = () => t('Loading...')
  const isControlled = props.value !== undefined
  const [innerValue, setInnerValue] = useState(props.defaultValue)
  // const defaultOptions = isControlled ? undefined : [props.defaultValue]

  const dummy = useRef(null)
  const handleChange = value => {
    if (props.onChange) {
      props.onChange(value)
    }
    setInnerValue(value)
    dummy.current.dispatchEvent(new Event('change'))
  }

  const valueToUse = isControlled ? props.value : innerValue

  useEffect(() => {
    setInnerValue(props.defaultValue)
  }, [props.defaultValue])

  return (
    <>
      <AsyncSelect
        className={props.selectClassName}
        name={props.name}
        placeholder={props.placeholder}
        isDisabled={props.readOnly}
        // defaultValue={props.defaultValue}
        // defaultOptions={defaultOptions}
        // defaultInputValue={props.defaultValue && props.defaultValue.lab}
        value={valueToUse}
        onChange={handleChange}
        classNamePrefix='styled-select--no-border styled-select'
        theme={getReactSelectTheme}
        loadOptions={loadOptions}
        components={customComponents}
        noOptionsMessage={noOptionsMessage}
        loadingMessage={loadingMessage}
        clearable={props.clearable}
      />
      <input
        tabIndex={-1}
        autoComplete='off'
        style={{ opacity: 0, position: 'absolute', pointerEvents: 'none' }}
        value={valueToUse}
        data-validateable-input
        required
        className={props.inputClass}
        ref={dummy}
      />
    </>
  )
}

AirportPicker.propTypes = {
  clearable: PropTypes.bool,
  inputClass: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  selectClassName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

AirportPicker.defaultProps = {
  selectClassName: '',
  clearable: false,
  inputClass: 'input-field',
  value: undefined,
}

export default AirportPicker
